import type { FlatConfig } from '../flatConfig';
import { getVendor, getVendorProductDb } from '../../config/vendorRegistry';

export type StorageSide = 'hybrid' | 'afa';

export interface RulesContext {
  capabilities: any;
  businessRules: any;
  productDb: any;
  metaState: any;
  // Minimal vendor identity needed by R4: getServicePartNumbers(serviceOption, vendor,
  // subscriptionMonths) resolves service part numbers from the vendor's declared
  // capabilities (registry-declared SKUs, falling back to vendor?.id for the legacy
  // AIC/DELL switches) combined with the current subscription duration — see
  // src/utils/partNumberUtils.jsx:104. Legacy passes the whole vendor object down through
  // applySharedBusinessRules; ctx carries just the id rather than the full vendor to keep
  // RulesContext narrow.
  vendorId: string;
}

export function buildContext(newFlat: FlatConfig, productDb: any, metaState: any, vendor: any): RulesContext {
  const currentVendor = getVendor(newFlat.hardwareVendor) || vendor;
  const currentProductDb = getVendorProductDb(newFlat.hardwareVendor) || productDb;
  return {
    capabilities: currentVendor.capabilities,
    businessRules: currentVendor.businessRules,
    productDb: currentProductDb,
    metaState: metaState || {},
    vendorId: currentVendor.id,
  };
}
